import React, {Component} from 'react';
import marketStyle from '../css/markets.css';

import OddsCard from './oddsCard';

class WinningMargin extends Component {
    render() {
        let store = this.props.store;
        let markets = this.props.markets;
        let firstColumn = markets.slice(0, 3);
        let secondColumn = markets.slice(3,6);
        let homeTeam = this.props.homeTeam.split(" ")[1];
        let awayTeam =  this.props.awayTeam.split(" ")[1];

        let firstColumnUI;
        if (firstColumn && firstColumn.length) {
            firstColumnUI = firstColumn.map((mkt, index) => (
                <OddsCard store={store} market={mkt} key={'fc' + index} removeTeam={true}/>));
        }

        let secondColumnUI;
        if (secondColumn && secondColumn.length) {
            secondColumnUI = secondColumn.map((mkt, index) => (
                <OddsCard store={store} market={mkt} key={'sc' + index} removeTeam={true}/>));
        }

        return (
            <div className={marketStyle.marketGroup}>
                <div className={marketStyle.scoreGroup}>
                    <div className={marketStyle.winningMarginTeamHeader}>
                        {homeTeam}
                    </div>
                    {firstColumnUI}
                </div>
                <div className={marketStyle.scoreGroup}>
                    <div className={marketStyle.winningMarginTeamHeader}>
                        {awayTeam}
                    </div>
                    {secondColumnUI}
                </div>
            </div>
        );
    }
}

export default WinningMargin;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/tennis/components/winningMargin.js